import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import React from 'react';

export interface IMenuItemProps extends MenuItemProps {}

const MenuItem: React.FC<IMenuItemProps> = ({ children, ...props }) => {
  return <Menu.Item {...props}>{children}</Menu.Item>;
};

export default MenuItem;
